export default __webpack_public_path__ + "static/media/lock-reset.f20032f0.svg";